<template>
  <div class="main">
    <div class="header">信息</div>
    <div class="message">
        <div class="standard">
            <div class="intro">姓名</div>
            <div class="infor">{{nickName}}</div>
        </div>
        <div class="standard">
            <div class="intro">开始时间</div>
            <div class="infor">{{beginTime}}</div>
        </div>
        <div class="standard">
            <div class="intro">结束时间</div>
            <div class="infor">{{endTime}}</div>
        </div>
    </div>
    <button class="button" @click="enterVideoChat">进入视频客服</button>
    <Modal v-model="popUp" :mask-closable="false" :closable="false" class="popUp">
        <div slot="header">
            <p style="text-align:center">
                <span>温馨提示</span>
            </p>
        </div>
        <div>
			<p>{{title}}</p>
        </div>
        <div slot="footer" class="popUpButton">
            <Button class="iconSpan" type="primary" size="large" @click="closeTitle" style="padding:5px 30px;width: 100%; border-radius: 0 0 4px 4px;">确定</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
    import {
        mapState,
        mapActions,
        mapMutations,
        mapGetters
    } from 'vuex';
    import util from '@/config/util'
    export default {
	    data(){
	    	return {
                // 进入视频客服按钮弹窗
                popUp: false,
                // 提示文本
                title:'',
                NotYetTime: true,
                titleTime: '',
                // 预约信息
                beginTime: '',
                endTime: '',
                arrivalTime: '',
                nickName : '',
                url: ''
            }
	    },
	    components:{
        
	    },
	    created(){
            this.$nextTick(function() {
                this.initData();
            }); 
	    },
        mounted() {
	    },
	    computed: {
        },
	    watch:{
	    },
	    methods:{
            ...mapActions([
				'getVideoServiceAction',
			]),
            initData() {
                this.getMsg()
            },
            async getMsg() {
                let sign = 'MyO'
                let Code = this.$route.query.id
                let res = await this.getVideoServiceAction({Code, sign})
                if(res?.data?.code === '-1') {
                    this.title = res.data.msg;
                    this.popUp = true;
                }else if(res?.data?.code === '1') {
                    this.url = res.data || ''
                    const match = this.url?.returnParams.match(/name=([^&]*)/)
                    this.nickName = match && match[1];
                    const match1 = this.url?.returnParams.match(/begintime=([^&]*)/)
                    this.beginTime = match1 && match1[1];
                    const match2 = this.url?.returnParams.match(/endtime=([^&]*)/)
                    this.endTime = match2 && match2[1];
                }
            },
            closeTitle() {
                this.popUp = false;
                if(this.NotYetTime) {
                    this.$router.push('/home')
                };
                this.NotYetTime = true;
            },
            enterVideoChat() {
                const beginTime = Date.fromStr(this.beginTime);
                const endTime = Date.fromStr(this.endTime);
                const currentTime = util.realNowTime();
                this.formatDateAndTime(this.beginTime,this.endTime)
                if (currentTime < beginTime) {
                    //当前时间未到
                    this.NotYetTime = false;
                    this.title = `亲爱的${this.nickName},您的预约时间是${this.titleTime},请您稍后进入，祝您生活愉快。`;
                    this.popUp = true;
                } else if(currentTime > endTime) {
                    // 当前时间已过
                    this.title = `亲爱的${this.nickName},您的预约时间是${this.titleTime},预约时间已过，请重新预约，祝您生活愉快。`;
                    this.popUp = true;
                } else if( currentTime > beginTime && currentTime < endTime) {
                    window.location.href = `${this.url?.SMSretParamsToServer}`;
                }
            },
            formatDateAndTime(beginTime,endTime) {
                const [date, time] = beginTime.split(' ');
                const [year,month, day] = date.split('-');
                const [date1, time1] = endTime.split(' ');
                this.titleTime = `${month}月${day}日 ${time}-${time1}`
            },
	    },
    }
</script>

<style lang="scss" scoped>
.main {
    position: absolute;
	width: 100%;
	height: 100%;
    font-size: 4vw;
    background-color: #f0f1f6;
    .header {
        height: 10vw;
        line-height: 10vw;
        margin-left: 5vw;
        color: #999999;
    }
    .message {
        background-color: #fff;
        .standard {
            display: flex;
            justify-content: flex-start;
            padding: 3.5vw 5vw;
            border-bottom: 1px solid #f0f1f6;
            .intro {
                width: 21vw
            }
            .infor {
                color: #cfcfcf;
            }
        }
    }
    .button {
        height: 14vw;
        width: 90vw;
        line-height: 14vw;
        text-align: center;
        border-radius: 10vw;
        border-width: 0;
        margin: 75vw 5vw 0;
        font-size: 4.5vw;
        background-color: #a672b0;
        color: #fff;
    }
    .popUp {
        .iconSpan {
            width: 100% !important;
            border-radius: 0 0 4px 4px;
        }
    }
}
</style>
<style lang="scss">
.popUp {
    .ivu-modal-header,.ivu-modal-footer {
        border-width: 0;
    }
    .ivu-modal-body {
        padding: 0px 16px 32px;
    }
    .ivu-modal-footer {
        padding: 0;
        border-radius: 0;
    }
    .ivu-modal-wrap * {
        text-align: center;
    }
    .ivu-btn-primary {
        background-color: #a672af;
        border-color: #a672af;
    }
    @media (max-width: 576px){
        .ivu-modal {
            margin: 50px;
        }
    }
}
</style>